import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-up-2-icon',
  templateUrl: './navigation-up-2.component.html'
})
export class NavigationUp2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
